// React import
import React, { useEffect } from 'react';
// App Constants
import { PATHS } from '../AppConstants';
import { ASSET_PATH } from 'assetsPath';

// Common style/component imports
import {
    MainWrapper,
    BgSection,
    InnerWrapper,
    LeftSection,
    RightSection,
    TopFloatingSection,
    HeadingWrapper,
    GenericSpan,
    FlexDiv,
    GenericDiv
} from 'common/Styles';
// Page heading import
import PageHeading from 'common/PageHeading/PageHeading';

// Budget management-specific imports
import BudgetOverviewSection from './components/BudgetOverviewHeader';

// config
import { textsConfig } from './config';

// Utils
import { clearSelectedBudgetsFromSession } from '../UtilityComponents/budgetUtils';

// styles
import { BudgetDashIcon, BudgetManagementRightSection } from './styles';


const imgPath = `${ASSET_PATH.IMAGES}budget/budgetIcon.png`;

const MainPage = () => {
    
    useEffect(() => {
        clearSelectedBudgetsFromSession();
    }, []);

    return (
    <MainWrapper type="auto">
        <BgSection bgColor="#efefef" minHt="93px">
            <InnerWrapper>
                <HeadingWrapper headingWidth="201px">
                    <PageHeading as="h2" fontSize="32" headingText={textsConfig.PAGE_HEAD_TEXT}>
                        <GenericSpan color="#757575" fsize="12px">
                            {textsConfig.PAGE_SUB_HEAD_TEXT}
                        </GenericSpan>
                    </PageHeading>
                </HeadingWrapper>
            </InnerWrapper>
        </BgSection>

        <InnerWrapper makeFlex paddingHr="20px 0" spaceBetween>
            <LeftSection $width="240px">
                <FlexDiv color="#FF664B" $cursor="pointer" justify="flex-start" align="center" onClick={() => { window.location.href = PATHS.DASHBOARD }}>
                    <BudgetDashIcon src={imgPath} />
                    <GenericDiv color="#FF664B" f_weight="400" left_M="5">{textsConfig.DASHBOARD_TEXT}</GenericDiv>
                </FlexDiv>
            </LeftSection>

            <BudgetManagementRightSection>
                <TopFloatingSection marginTop="-124px" bdrRad="14px">
                    {/* Budget Overview Section */}
                    <BudgetOverviewSection />
                </TopFloatingSection>
            </BudgetManagementRightSection>
        </InnerWrapper>
    </MainWrapper>
    );
};

export default MainPage;
